import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { NavLink, useNavigate } from "react-router-dom";
import { GoogleSingIn } from "./GoogleSingIn";
import { postRequest } from "../../Services/axios.service";
import { LOGIN } from "../../Utils/url.api";
import { toast, ToastContainer } from "react-toastify";
import useUser from "../../Context/hook/useUser";
import { SignUpDone } from "./SignUpDone";
import jwtDecode from "jwt-decode";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import axios from "axios";
export const Login = () => {
  const parkId = useSelector((state) => state.ui.parkId);
  const wasFromPay = useSelector((state) => state.ui.fromPay);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur", reValidateMode: "onSubmit" });
  const { login, isAuth } = useUser();
  const navigate = useNavigate();
  const [logged, setLogged] = useState(isAuth());

  const submitLogin = (data) => {
    loginWithCredentials(data);
  };

  const loginWithCredentials = async (formValue) => {
    toast
      .promise(
        axios.post(
          "https://apigateway.ambiente.gob.do/authApi/auth/login",
          formValue
        ),
        {
          pending: {
            position: "top-center",
            type: "default",
            isLoading: true,
            icon: false,
            render: () => "Espere",
          },
          error: {
            render: () => "El inicio de sesión ha fallado",
          },
        }
      )
      .then(({ data }) => {
        if (data?.statusCode === 401 && data?.notRegistered) {
          toast.warning(data?.message, {
            autoClose: 2000,
            position: "top-center",
            theme: "colored",
          });
        } else if (data?.statusCode === 401) {
          toast.error(data?.message, {
            autoClose: 2000,
            position: "top-center",
            theme: "colored",
          });
        } else if (data?.accessToken) {
          const { accessToken, expireAt } = data;
          login(accessToken, expireAt);
          const decode = jwtDecode(accessToken);
          if (decode.EmailVerify == "0") {
            navigate("/verify");
          } else if (decode.ChangePassword == "1") {
            navigate("/change-password");
          } else {
            setLogged((log) => true);
            if (wasFromPay) {
              navigate(`/detail/payment/${parkId}`);
            }
          }
        }
      });
  };

  const LogPage = () => (
    <div className="text-lg">
      <ToastContainer />
      <span className="text-xl font-medium text-font-primary">
        Coloca tu correo electrónico y contraseña para iniciar sesión
      </span>
      <div className="text-left my-8">
        <form
          className="custom-form"
          onSubmit={handleSubmit((data) => submitLogin(data))}
        >
          <div className="custom-form__control">
            <label className="custom-form__label">Correo Electrónico</label>
            <input
              className="custom-form__input"
              id="email"
              type="email"
              {...register("email", {
                required: true,
                pattern: {
                  value:
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: "Correo invalido",
                },
              })}
            />
            {errors.email?.type === "required" && (
              <p className="text-danger" role="alert">
                El correo electrónico es requerido
              </p>
            )}
            {errors.email?.type === "pattern" && (
              <p className="text-danger" role="alert">
                {errors.email?.message}
              </p>
            )}
          </div>

          <div className="custom-form__control">
            <label className="custom-form__label">Contraseña</label>
            <input
              className="custom-form__input"
              id="password"
              type="password"
              {...register("password", {
                required: true,
              })}
            />
            <span>
              {errors.password?.type === "required" && (
                <p className="text-danger" role="alert">
                  La contraseña es requerida
                </p>
              )}
            </span>
          </div>
          <div className="flex flex-col space-y-4 items-center gap-x-2">
            <button
              className=" w-full uppercase rounded-[20rem] bg-primary text-xl rounded px-8 py-4 text-white"
              type="submit"
            >
              Iniciar Sesión
            </button>
            {wasFromPay && (
              <button
                className=" w-full uppercase  rounded-[20rem] bg-warning text-black text-xl rounded px-8 py-4 text-white"
                onClick={() => {
                  navigate(`/detail/guest/payment/${parkId}`);
                }}
              >
                Pagar como Invitado
              </button>
            )}
          </div>
          <div className="mt-4 ">
            <GoogleSingIn setLogged={setLogged}></GoogleSingIn>
          </div>
        </form>
      </div>
      <div className="text-xl my-4">
        <p>¿No tienes cuenta aún?</p>
        <NavLink className={"link"} to={"/login/sign-up"}>
          Registrarse
        </NavLink>
      </div>
    </div>
  );

  return <>{logged ? <SignUpDone></SignUpDone> : <LogPage></LogPage>}</>;
};
